import { createContext } from 'react';
import useFetch from '../../../hooks/useFetch';

const nodate = new Date(0);
const ApplicationWindowContext = createContext({
  opening: nodate,
  soft_deadline: nodate,
  hard_deadline: nodate,
});
export default ApplicationWindowContext;

const ApplicationWindowContextProvider = ({ children, chapter_id }) => {
  console.log(
    'ApplicationWindowContextProvider rendered with children:',
    children?.type?.name || 'Unknown component'
  );
  console.log('ApplicationWindowContextProvider chapter_id:', chapter_id);

  const { data, error, loading } = useFetch('/api/application_windows/all');

  console.log('ApplicationWindowContext API response:', {
    data,
    error,
    loading,
  });

  if (error) {
    console.error('ApplicationWindowContext error:', error);
  }

  const nonDate = new Date(0);

  // Handle the data - filter by chapter_id if provided
  let windowData = {};
  if (data) {
    if (Array.isArray(data)) {
      if (chapter_id) {
        // Find window for specific chapter
        windowData =
          data.find((window) => window.chapter_id === parseInt(chapter_id)) ||
          data[0] ||
          {};
        console.log(`Found window for chapter ${chapter_id}:`, windowData);
      } else {
        // Use first window if no chapter specified
        windowData = data[0] || {};
        console.log('Using first available window:', windowData);
      }
    } else {
      // If it's a single object, use it directly
      windowData = data;
    }
  }

  const {
    opening = nonDate,
    soft_deadline = nonDate,
    hard_deadline = nonDate,
  } = windowData;

  const value = {
    opening: new Date(opening),
    soft_deadline: new Date(soft_deadline),
    hard_deadline: new Date(hard_deadline),
    loading,
    error,
    chapter_id: chapter_id,
    windowData: windowData, // Include the full window data for debugging
    // Add helper functions to the context
    isApplicationWindowOpen: () => {
      const now = new Date();
      return now >= new Date(opening) && now <= new Date(hard_deadline);
    },
    getWindowStatus: () => {
      const now = new Date();
      const openingDate = new Date(opening);
      const hardDeadlineDate = new Date(hard_deadline);
      
      if (!opening || !hardDeadlineDate) return 'No information available';
      if (now < openingDate) return 'Opens Soon';
      if (now > hardDeadlineDate) return 'Closed';
      return 'Open Now';
    },
    formatDate: (dateString) => {
      if (!dateString) return 'Not specified';
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'Invalid date';

        return new Intl.DateTimeFormat('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          timeZone: 'UTC' // Force UTC to prevent timezone shifts
        }).format(date);
      } catch (err) {
        return 'Invalid date';
      }
    }
  };

  console.log('ApplicationWindowContext final values:', {
    opening: value.opening.toISOString(),
    soft_deadline: value.soft_deadline.toISOString(),
    hard_deadline: value.hard_deadline.toISOString(),
    chapter_id: value.chapter_id,
    windowData: value.windowData,
    isOpen: value.isApplicationWindowOpen(),
    status: value.getWindowStatus()
  });

  return (
    <ApplicationWindowContext.Provider value={value}>
      {children}
    </ApplicationWindowContext.Provider>
  );
};

export { ApplicationWindowContextProvider };